import { Action, Reducer } from '@reduxjs/toolkit';

export const mixReducers = <T>(...reducers: Reducer<T>[]) => (state: T, action: Action<any>) =>
  reducers.reduce((state, reducer) => reducer(state, action), state);
